import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";



const tariffRoutes = {
    LIST_TARIFF: "dashboard/billing/tariff/list-complete"
};

export default {
    tariffList(companyId) {
        let newInfo = [];
        return new Promise(resolve => {
            http.get(tariffRoutes.LIST_TARIFF,
                {params: {companyId}}
            ).then(({data}) => {
                const code = data.code;
                if (code === 0) {
                    toast.info("No se encontraron tarifas ");
                    return;
                }
                if (code < 0) {
                    toast.error("Error al consultar las tarifas");
                    return;
                }
                const tariffList = data.info;
                this.processTariff(tariffList);
                newInfo = tariffList;
            }).catch(() => toast.error("Error al consultar las tarifas"))
                .finally(() => resolve(newInfo));
        });
    },

    processTariff(tariffs){
        tariffs.forEach( tariff => {
            tariff.id = tariff.code;
            tariff.label = tariff.title;
        });
    },
};